const newsletterData = {
  heading: 'Zapisz się do newslettera',
  sub: 'Bądź na bieżąco z naszymi ofertami.',
  accept: 'Akceptuję ',
  privacyPolicy: 'politykę prywatności.',
  PPLink: '/polityka-prywatnosci',
  inputPlaceholder: 'Podaj nam swój adres e-mail',
  buttonValue: 'zapisz się',
  sending: 'wysyłam...',
  success: 'Dziękujemy za subskrypcję!',
  error: 'Niespodziewany problem',
  empty: 'Podaj poprawny adres mailowy',
  duplicate: 'Zbyt dużo prób subskrypcji na ten adres mailowy'
};

export { newsletterData };